import { CabinetCard } from "@/components/Card";
import classNames from "classnames";
import { getHashrateValue } from "@/shared";
import style from "./index.module.scss";
import { useSubAccount } from "@/hooks";
import { useTranslations } from "use-intl";
import { IWatcherLinkSubAccount } from "@/models";

interface IProps {
  earnings: Array<any>;
  summary: any;
  watcherSubAccountInfo?: IWatcherLinkSubAccount | null;
}

const coins = ["BTC", "BCH", "LTC", "KAS", "ALPH", "ZEC"];

// "Последний доход": every row of the latest day, so an Antpool refund (a
// second earning of the day) is counted like on the dashboard.
const lastDayIncome = (earnings: Array<any>) => {
  if (!earnings.length) {
    return 0;
  }
  const latest = Math.max(...earnings.map((e) => new Date(e.date).getTime()));
  return earnings
    .filter((e) => new Date(e.date).getTime() === latest)
    .reduce((sum, e) => sum + Number(e.total_profit || 0), 0);
};

export function HomeCards({
  summary,
  earnings,
  watcherSubAccountInfo,
}: IProps) {
  let { currentSubAccountInfo } = useSubAccount();
  if (watcherSubAccountInfo) {
    currentSubAccountInfo = watcherSubAccountInfo;
  }
  const i18n = useTranslations("cabinet.home");
  return (
    <div className={style.home__blocks}>
      <div className={style.home__desktop}>
        <div className={style.home__blocks__first}>
          <CabinetCard>
            <div className={classNames(style.card, style.withIcon)}>
              <div>
                <span className={style.card__label}>
                  {i18n("summaryBlock.lastEarning")}
                </span>
                <h3 className={style.card__title}>
                  {earnings.length ? lastDayIncome(earnings).toFixed(8) : 0}
                  <span className={style.card__subtitle}>
                    {currentSubAccountInfo?.crypto_currency || "BTC"}
                  </span>
                </h3>
                <h6 className={style.card__equal}></h6>
              </div>
              <div className={style.card__img}>
                <img
                  src={require(
                    `@/images/main/coins/${coins.includes(currentSubAccountInfo?.crypto_currency) ? currentSubAccountInfo?.crypto_currency : "BTC"}.png`,
                  )}
                  width={
                    currentSubAccountInfo?.crypto_currency === "ZEC" ? 90 : 70
                  }
                  style={{ objectFit: "cover" }}
                  alt={"btc"}
                />
              </div>
            </div>
          </CabinetCard>
          <CabinetCard>
            <div className={style.card}>
              <span className={style.card__label}>
                {i18n("summaryBlock.currentHashrate")}
              </span>
              <h3 className={style.card__title}>
                {
                  getHashrateValue(
                    summary[0].hashrate_10min as number,
                    currentSubAccountInfo?.crypto_currency,
                  ).val
                }
                <span className={style.card__subtitle}>
                  {
                    getHashrateValue(
                      summary[0].hashrate_10min || 0,
                      currentSubAccountInfo?.crypto_currency,
                    ).unit
                  }
                </span>
              </h3>
            </div>
          </CabinetCard>
          <CabinetCard>
            <div className={style.card}>
              <span className={style.card__label}>
                {i18n("summaryBlock.onlineWorker")}
              </span>
              <h3 className={classNames(style.card__title, style.green)}>
                {summary[0].active_workers}
              </h3>
            </div>
          </CabinetCard>
        </div>
        <div className={style.home__blocks__first}>
          <CabinetCard>
            <div className={classNames(style.card, style.withIcon)}>
              <div>
                <span className={style.card__label}>
                  {i18n("summaryBlock.balance")}
                </span>
                <h3 className={style.card__title}>
                  {summary[0].balance}
                  <span className={style.card__subtitle}>
                    {currentSubAccountInfo?.crypto_currency || "BTC"}
                  </span>
                </h3>
                <h6 className={style.card__equal}></h6>
              </div>
              <div className={style.card__img}>
                <img
                  src={require(
                    `@/images/main/coins/${coins.includes(currentSubAccountInfo?.crypto_currency) ? currentSubAccountInfo?.crypto_currency : "BTC"}.png`,
                  )}
                  width={
                    currentSubAccountInfo?.crypto_currency === "ZEC" ? 90 : 70
                  }
                  alt={"btc"}
                />
              </div>
            </div>
          </CabinetCard>
          <CabinetCard>
            <div className={style.card}>
              <span className={style.card__label}>
                {i18n("summaryBlock.average")}
              </span>
              <h3 className={style.card__title}>
                {
                  getHashrateValue(
                    summary[0].hashrate_24hour as number,
                    currentSubAccountInfo?.crypto_currency,
                  ).val
                }
                <span className={style.card__subtitle}>
                  {
                    getHashrateValue(
                      summary[0].hashrate_24hour || 0,
                      currentSubAccountInfo?.crypto_currency,
                    ).unit
                  }
                </span>
              </h3>
            </div>
          </CabinetCard>
          <CabinetCard>
            <div className={style.card}>
              <span className={style.card__label}>
                {i18n("summaryBlock.offlineWorker")}
              </span>
              <h3 className={classNames(style.card__title, style.red)}>
                {summary[0].unactive_workers}
              </h3>
            </div>
          </CabinetCard>
        </div>
      </div>
      {MobileInfoBlocks(i18n, earnings, summary[0], currentSubAccountInfo)}
    </div>
  );
}
const MobileInfoBlocks = (
  i18n: any,
  earnings: any,
  summary: any,
  subAccount: any,
) => {
  return (
    <div className={style.home__mobile}>
      <div className={style.home__blocks__first}>
        <div className={style.home__mobile__extend}>
          <CabinetCard>
            <div className={classNames(style.card, style.withIcon)}>
              <div>
                <span className={style.card__label}>
                  {i18n("summaryBlock.lastEarning")}
                </span>
                <h3 className={style.card__title}>
                  {earnings.length ? lastDayIncome(earnings).toFixed(8) : 0}
                  <span className={style.card__subtitle}>
                    {subAccount?.crypto_currency || "BTC"}
                  </span>
                </h3>
                <h6 className={style.card__equal}></h6>
              </div>
              <div className={style.card__img}>
                <img
                  src={require(
                    `@/images/main/coins/${coins.includes(subAccount?.crypto_currency) ? subAccount?.crypto_currency : "BTC"}.png`,
                  )}
                  width={40}
                  alt={"btc"}
                />
              </div>
            </div>
          </CabinetCard>
          <CabinetCard>
            <div className={classNames(style.card, style.withIcon)}>
              <div>
                <span className={style.card__label}>
                  {i18n("summaryBlock.balance")}
                </span>
                <h3 className={style.card__title}>
                  {summary.balance}
                  <span className={style.card__subtitle}>
                    {subAccount?.crypto_currency || "BTC"}
                  </span>
                </h3>
                <h6 className={style.card__equal}></h6>
              </div>
              <div className={style.card__img}>
                <img
                  src={require(
                    `@/images/main/coins/${coins.includes(subAccount?.crypto_currency) ? subAccount?.crypto_currency : "BTC"}.png`,
                  )}
                  width={40}
                  alt={"btc"}
                />
              </div>
            </div>
          </CabinetCard>
        </div>
      </div>
      <div
        className={classNames(
          style.home__blocks__first,
          style.home__mobile__equalize,
        )}
      >
        <CabinetCard>
          <div className={style.card}>
            <span className={style.card__label}>
              {i18n("summaryBlock.currentHashrate")}
            </span>
            <h3 className={style.card__title}>
              {
                getHashrateValue(
                  summary.hashrate_10min || 0,
                  subAccount?.crypto_currency,
                ).val
              }
              <span className={style.card__subtitle}>
                {
                  getHashrateValue(
                    summary.hashrate_10min || 0,
                    subAccount?.crypto_currency,
                  ).unit
                }
              </span>
            </h3>
          </div>
        </CabinetCard>
        <CabinetCard>
          <div className={style.card}>
            <span className={style.card__label}>
              {i18n("summaryBlock.average")}
            </span>
            <h3 className={style.card__title}>
              {
                getHashrateValue(
                  summary.hashrate_24hour as number,
                  subAccount?.crypto_currency,
                ).val
              }
              <span className={style.card__subtitle}>
                {
                  getHashrateValue(
                    summary.hashrate_24hour || 0,
                    subAccount?.crypto_currency,
                  ).unit
                }
              </span>
            </h3>
          </div>
        </CabinetCard>
      </div>
      <div
        className={classNames(
          style.home__blocks__first,
          style.home__mobile__equalize,
        )}
      >
        <CabinetCard>
          <div className={style.card}>
            <span className={style.card__label}>
              {i18n("summaryBlock.onlineWorker")}
            </span>
            <h3 className={classNames(style.card__title, style.green)}>
              {summary.active_workers}
            </h3>
          </div>
        </CabinetCard>
        <CabinetCard>
          <div className={style.card}>
            <span className={style.card__label}>
              {i18n("summaryBlock.offlineWorker")}
            </span>
            <h3 className={classNames(style.card__title, style.red)}>
              {summary.unactive_workers}
            </h3>
          </div>
        </CabinetCard>
      </div>
    </div>
  );
};
